import logo from './logo.svg';
import './App.css';
import BmiCalculator from './bmiCal';

function App() {
  return (
    <>
    <BmiCalculator/>    
    
    </>
  );
}

export default App;
